import { graphql } from '@/gql/gql'

export const GET_FREE_SHIPPING_RATES_QUERY = graphql(`
  query GetFreeShippingRates {
    freeShippingRates {
      zoneName
      minAmountEUR
    }
  }
`)
